import { ArrowRight, Mail, MapPin, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const Contact = () => {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 via-white to-yellow-50/30">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Let's Work Together
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            We are a 100% remote organization and deal with companies from the bottom of the South Island to the tip of the North Island.
          </p>
        </div>
      </section>

      {/* Contact Cards */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {[
              {
                icon: Mail,
                title: 'Email Us',
                content: 'bronny@mpremarketing.com',
                description: 'Send us an email anytime'
              },
              {
                icon: MapPin,
                title: 'Location',
                content: 'New Zealand',
                description: '100% Remote Organization'
              },
              {
                icon: Phone,
                title: 'Book a Call',
                content: 'Schedule a Meeting',
                description: 'Free 30-minute consultation'
              }
            ].map((item, index) => {
              const Icon = item.icon;
              return (
                <Card key={index} className="border-2 hover:border-[#FBD116] transition-all duration-300">
                  <CardContent className="p-8 text-center">
                    <div className="w-16 h-16 rounded-full bg-[#FBD116]/10 flex items-center justify-center mx-auto mb-6">
                      <Icon className="w-8 h-8 text-gray-900" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{item.title}</h3>
                    <p className="text-gray-700 font-medium mb-1">{item.content}</p>
                    <p className="text-sm text-gray-600">{item.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          {/* Main CTA */}
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Book a chat with one of our staff
            </h2>
            <Button
              asChild
              size="lg"
              className="bg-[#FBD116] hover:bg-[#E5C015] text-gray-900 font-semibold text-lg px-8"
            >
              <a href="https://calendly.com/bronny-mpremarketing/30min" target="_blank" rel="noopener noreferrer">
                Book Now
                <ArrowRight className="ml-2 w-5 h-5" />
              </a>
            </Button>
          </div>
        </div>
      </section>

      {/* Image */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1200&h=675&fit=crop"
              alt="Team Meeting"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* Why Work With Us */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-12">
            Why Work With Unite Marketing?
          </h2>
          <div className="grid md:grid-cols-2 gap-8 text-left">
            {[
              {
                title: 'Efficient & Knowledgeable',
                description: 'Our team has worked with major brands including Xero, Microsoft, and TradeMe.'
              },
              {
                title: 'Strategic Capability',
                description: 'We get things done efficiently and strategically, at a fraction of the cost.'
              },
              {
                title: 'MSP Specialists',
                description: '7+ years of experience working specifically with Managed Service Providers.'
              },
              {
                title: 'Honest & Respectful',
                description: 'We believe in being straight up, honest and respectful in all our dealings.'
              }
            ].map((item, index) => (
              <div key={index} className="p-6 border-2 border-gray-200 rounded-xl hover:border-[#FBD116] transition-colors">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Book a no-obligation chat or free marketing audit today.
          </p>
          <Button
            asChild
            size="lg"
            className="bg-[#FBD116] hover:bg-[#E5C015] text-gray-900 font-semibold text-lg px-8"
          >
            <a href="https://calendly.com/bronny-mpremarketing/30min" target="_blank" rel="noopener noreferrer">
              Book Your Free Call
              <ArrowRight className="ml-2 w-5 h-5" />
            </a>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Contact;
